<template>
  <div class="read-page">
    <div class="left-book">
      <img class="tip-box" src="@/assets/images/welcome/tip-box.png" alt="" />
      <img
        class="read-book"
        src="@/assets/images/welcome/ai-reader-book.png"
        alt=""
      />
    </div>
    <div class="course-card">
      <div class="card-title">欢迎加入AI阅读</div>
      <div class="line"></div>
      <div class="tip">请选择您的学段学科</div>
      <div class="course-item">
        <span class="course-name">学段：</span>
        <div
          class="item"
          data-io-click="tracker"  @click="changeCurrentStageIndex(index)"
          :class="{ active: index == currentStageIndex }"
          v-for="(item, index) in userCourses"
          :key="item.id"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="course-item">
        <span class="course-name">学科：</span>
        <div
          class="item"
          data-io-click="tracker"  @click="changeCurrentSubjectIndex(index)"
          :class="{ active: index == currentSubjectIndex }"
          v-for="(item, index) in subjectList"
          :key="item.subjectId"
        >
          {{ item.subjectName }}
        </div>
      </div>
      <div
        class="submit-btn"
        data-io-click="tracker"  @click="handleChooseCurrentCourse"
        :class="{
          active: currentStageIndex != null && currentSubjectIndex != null,
        }"
      >
        确定
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStageSubjectList,
  getUserUsedCourse,
  addCourse,
  updateLastUsedCourse,
} from "@/utils/apis";
import { mapState, mapMutations } from "vuex";
const CURRENTCOURSE = "CURRENTCOURSE";
export default {
  inject: ["textbook"],
  data() {
    return {
      subjectList: [],
      currentStageIndex: null,
      currentSubjectIndex: null,
    };
  },
  computed: {
    ...mapState(["userCourses", "currentCourse", "userInfo"]),
  },
  async mounted() {
    // await this.getStageSubjectList();
    // this.getUserUsedCourse();
  },
  watch: {
    currentStageIndex(val) {
      this.subjectList = this.userCourses[val].courseList;
    },
    currentCourse: {
      handler(val, oldVal) {
        console.log("val, oldVal---", val, oldVal);
        if (val) {
          let { stageId, subjectId } = val;
          if (val.isLastUsedCourse) {
            this.$router.replace("/read/");
            return;
          }
          // console.log("=---val", val, this.userCourses);
          if (this.userCourses?.length && stageId && subjectId) {
            for (let i = 0; i < this.userCourses.length; i++) {
              let item = this.userCourses[i];
              if (item.id == stageId) {
                if (item?.courseList?.length) {
                  let findIndex = item.courseList.findIndex(
                    (course) => course.subjectId == subjectId
                  );
                  console.log("findIndex", findIndex);
                  if (findIndex > -1) {
                    this.currentStageIndex = i;
                    this.currentSubjectIndex = findIndex;
                    return;
                  }
                }
              }
            }
          } else {
            // this.currentStageIndex = 0;
            this.subjectList = this.userCourses[0].courseList;
            // this.currentSubjectIndex = findIndex;
          }
        }
      },
      immediate: true,
    },
    userCourses: {
      handler(val) {
        if (val) {
          console.log("va-----l", val);
          if (val?.length) {
            for (let i = 0; i < val.length; i++) {
              let item = val[i];
              if (item?.courseList?.length) {
                let findIndex = item.courseList.find((course) => course.isUse);
                console.log("findIndex", findIndex);
                if (findIndex > -1) {
                  subjectList = item.courseList;
                  this.currentStageIndex = i;
                  this.currentSubjectIndex = findIndex;
                  return;
                }
              }
            }
          }
          // this.subjectList = val[0].subjectList;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["setCurrentCourse", "changeHasAiUsedCourses"]),
    async getUserUsedCourse() {
      let { result } = await getUserUsedCourse();
      let { stageId, subjectId } = result;
      this.stageSubjectList.forEach((stage) => {
        if (stage.id == stageId) {
          stage.subjectList.forEach((subject) => {
            if (subject.id == subjectId) {
              let currentCourse = subject.course;
              currentCourse.stageId = stage.id;
              currentCourse.stageName = stage.name;
              currentCourse.subjectId = subject.id;
              currentCourse.subjectName = subject.name;
              console.log("当前课程", currentCourse);
              this.setCurrentReadCourse(currentCourse);
            }
          });
        }
      });
    },
    async getStageSubjectList() {
      let data = await getStageSubjectList();
      this.stageSubjectList = data.result || [];
      this.subjectList = this.stageSubjectList[0].subjectList;
      // console.log("----data", data);
    },
    changeCurrentStageIndex(index) {
      this.currentStageIndex = index;
    },
    changeCurrentSubjectIndex(index) {
      this.currentSubjectIndex = index;
    },
    async handleChooseCurrentCourse() {
      if (this.currentStageIndex != null && this.currentSubjectIndex != null) {
        // 设置当前课程
        let currentStage = this.userCourses[this.currentStageIndex];
        let currentCourse = currentStage.courseList[this.currentSubjectIndex];
        if (!currentCourse.isUse) {
          // 如果没有添加过需要重新添加一次课程
          let { result } = await addCourse({
            stageId: currentStage.id,
            subjectId: currentCourse.subjectId,
          });
          console.log("添加课程", result);
        }
        let { result } = await updateLastUsedCourse({
          stageId: currentStage.id,
          subjectId: currentCourse.subjectId,
          productId: this.textbook.productId,
        });
        if (result) {
          currentCourse.isLastUsedCourse = true;
          this.setCurrentCourse(currentCourse);
          this.$router.replace("/read/");
          // 跳转到到对应的页面
        }
        console.log("更新课程", result);
        localStorage.setItem(
          `${this.userInfo.userId}-` + CURRENTCOURSE,
          JSON.stringify(currentCourse)
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.read-page {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/welcome/ai-reader-bg.png");
  background-color: #e5f1ff;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .left-book {
    display: flex;
    flex-direction: column;
    margin-top: -88px;
    .tip-box {
      width: 314px;
      height: 120px;
    }
    .read-book {
      width: 503px;
      height: 412px;
      margin-left: -154px;
      margin-top: -4px;
    }
  }
  .course-card {
    // width: 374px;
    padding: 42px;
    height: fit-content;
    border-radius: 16px;
    border: 1px solid #fff;
    background: linear-gradient(
      138deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    box-shadow: 0px 12px 30px 0px rgba(30, 80, 121, 0.1);
    backdrop-filter: blur(2px);
    margin-left: 58px;
    .card-title {
      font-size: 36px;
      line-height: 1;
      color: #000;
      margin-bottom: 12px;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0057ff;
      margin-bottom: 36px;
    }
    .tip {
      font-size: 16px;
      line-height: 24px;
      color: #666666;
    }
    .course-item {
      margin-top: 24px;
      display: flex;
      align-items: center;
      .course-name {
        font-size: 14px;
        color: #666666;
        margin-right: 8px;
      }
      .item {
        padding: 0 8px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        font-size: 14px;
        color: #1a1a1a;
        background: #fff;
        margin-right: 12px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          background: #e6f2ff;
          color: #0057ff;
        }
        &.active {
          background: #0057ff;
          color: #fff;
          &:hover {
            background: #0057ff;
          }
        }
      }
    }
    .submit-btn {
      cursor: pointer;
      text-align: center;
      margin-top: 60px;
      height: 42px;
      line-height: 42px;
      border-radius: 6px;
      font-size: 14px;
      color: #fff;
      background: #99ccff;
      &.active {
        background: #0057ff;
      }
      &:hover {
        background: #4494ff;
      }
    }
  }
}
</style>
